
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop } from 'vue-property-decorator';
import { STATUS_QTS_SEMANAL } from "./constantes";
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";
import QuadroHorarioService from "@/service/v1/sigap/QuadroHorarioService";

@Options({
    name: "QtsSemanalCadastro",
    components: { Multiselect, BotaoSalvar },
    emits: ['qts-semanal-alterado'],
})
export default class QtsSemanalCadastro extends Vue {

    @Prop() readonly modal!: any
    @Prop() readonly perfis!: any
    @Prop() readonly turma!: any

    public service = new QtsSemanalService();
    public quadroService = new QuadroHorarioService();

    public processando = false;
    public statusOpcoes = STATUS_QTS_SEMANAL;
    public quadros: any = [];

    public descricao: any = null;
    public quadroHorarioId: any = null;
    public status: number = STATUS_QTS_SEMANAL[0].value;
    public dataInicio = '';
    public dataFim = '';
    public observacao: any = null;

    public async created() {
        await this.buscarQuadros();
    }

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get turmaId() {
        return this.turma ? this.turma.id : this.$route.params.id;
    }

    get quadros_select() {
        return this.quadros ? this.quadros.map((i) => ({ value: i.id, label: i.descricao })) : [];
    }

    public async buscarQuadros() {
        await this.quadroService.getAll(`turmaId=${this.turmaId}&take=1000`)
            .then(response => { this.quadros = response.data; })
            .catch(() => { this.quadros = []; });
    }

    public limpar() {
        this.descricao = null;
        this.quadroHorarioId = null;
        this.status = STATUS_QTS_SEMANAL[0].value;
        this.dataInicio = '';
        this.dataFim = '';
        this.observacao = null;
    }

    public sucesso() {
        this.$emit("qts-semanal-alterado");
        this.limpar();
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public getdados() {
        return {
            turmaId: this.turmaId,
            descricao: this.descricao,
            quadroHorarioId: this.quadroHorarioId,
            status: this.status,
            inicio: this.dataInicio || null,
            fim: this.dataFim || null,
            observacao: this.observacao || null,
        };
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) return;
        if (!this.descricao) {
            SiteUtils.toastErro('Erro!', 'Informe a descrição.');
            return;
        }
        if (this.dataInicio && this.dataFim && this.dataInicio > this.dataFim) {
            SiteUtils.toastErro('Erro!', 'A data início deve ser menor ou igual à data fim.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Geração cadastrada com sucesso!', response?.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Erro!', error?.data?.message);
                });
        }, 100);
    }
}
